<template>
  <div>
    <h3 class="my-6">Informações da Nota</h3>
    <v-row class="d-flex justify-space-between">
      <v-col cols="5">
        <v-row>
          <v-col>
            <CompanySelect v-model="form.company" ref="CompanySelect" />
          </v-col>
          <v-col cols="12"
            ><SupplierSearch v-model="form.supplier" ref="SupplierSearch"
          /></v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-row>
          <v-col>
            <app-text-field v-model="form.number" label="Numero da Nota" />
          </v-col>
          <v-col>
            <app-text-field v-model="form.serie" label="Série" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-text-field
              v-model="form.emited_at"
              label="Data Emissão"
              type="date"
            />
          </v-col>
          <v-col>
            <app-text-field v-model="form.mod" label="Modelo" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <app-text-field
              v-model="form.entry_at"
              label="Data Entrada"
              type="date"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SupplierSearch from "@/components/suppliers/ui/SupplierSearch.vue";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
export default {
  components: {
    SupplierSearch,
    CompanySelect,
  },
  props: {
    value: {},
  },

  data() {
    return {
      form: {},
    };
  },

  watch: {
    value(val) {
      this.form = val;
    },

    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  created() {
    this.form = this.value;
  },
};
</script>